export class ProductType {
  label: string;
  value: string;
  constructor(label, value) {
    this.label = label;
    this.value = value;
  }
}

export const ProductTypes = {
  WINDOWSTICKER: new ProductType('Raamsticker (standaard)', 'WindowSticker'),
  CUSTOMWINDOWSTICKER: new ProductType(
    'Raamsticker (op maat)',
    'CustomWindowSticker'
  ),
  BOARD: new ProductType('Projectbord', 'Board'),
  OTHER_PRODUCT: new ProductType('Andere', 'OtherProduct'),
  IP_BOARD: new ProductType('IP-bord', 'IPBoard')
};
